import type { AttachmentDTO, ConversationDetailDTO, ConversationDTO, SendMessageResponse } from '@sam/shared';
import { api } from './api';
import { keys, queryClient } from './queries';
import { followTurn } from './turns';

/** Odešle zprávu (do nové konverzace při `conversationId = 'new'`), zapíše ji do cache a napojí se na tah. */
export async function sendMessage(
  conversationId: string,
  text: string,
  attachments: AttachmentDTO[] = [],
  context?: { transcriptsClient?: { slug: string; name: string } },
): Promise<SendMessageResponse> {
  const r = await api<SendMessageResponse>('POST', `/conversations/${conversationId}/messages`, { text, attachments: attachments.map((a) => a.id), ...(context ? { context } : {}) });
  const id = r.conversation.id;
  queryClient.setQueryData<ConversationDetailDTO>(keys.conversation(id), (old) => ({
    ...(old ?? { ...r.conversation, messages: [] }),
    activeTurnId: r.turnId,
    messages: [...(old?.messages ?? []), r.userMessage, r.assistantMessage],
  }));
  queryClient.setQueryData<ConversationDTO[]>(keys.conversations, (old) => {
    const rest = (old ?? []).filter((c) => c.id !== id);
    return [{ ...r.conversation, activeTurnId: r.turnId, updatedAt: new Date().toISOString() }, ...rest];
  });
  followTurn({ turnId: r.turnId, conversationId: id, messageId: r.assistantMessage.id });
  return r;
}
